(function () {
  angular.module("akitabox.serviceRequest.newList", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.request",
  ]);
})();
